import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  DOCUMENT_EXPERT_DETAILS_GET,
  DOCUMENT_EXPERT_GET_COMMENTS,
  DOCUMENT_EXPERT_SET_COMMENT,
  DOCUMENT_EXPERT_SET_COMMENT_REPLY,
  DOCUMENTS_EXPERT_CATEGORIES_GET,
  DOCUMENTS_EXPERT_DOCUMENT_CREATE,
  DOCUMENTS_EXPERT_DOCUMENT_DELETE,
  DOCUMENTS_EXPERT_LIST_GET,
} from '../actions/documentsExpert';
import documentsExpert from '../../api/documentsExpert';

function* documentsExpertListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      documentsExpert.documentsExpertListGet,
      {
        filters,
      }
    );
    yield put({ type: DOCUMENTS_EXPERT_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentsExpertListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentsExpertListGetWatch() {
  yield takeLatest(DOCUMENTS_EXPERT_LIST_GET._REQUEST, documentsExpertListGet);
}

function* documentExpertDetailsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documentsExpert.documentExpertDetailsGet,
      {
        id,
      }
    );
    yield put({ type: DOCUMENT_EXPERT_DETAILS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertDetailsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertDetailsGetWatch() {
  yield takeLatest(
    DOCUMENT_EXPERT_DETAILS_GET._REQUEST,
    documentExpertDetailsGet
  );
}

function* documentExpertCategoriesGet({ show_all }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documentsExpert.documentExpertCategoriesGet,
      { show_all }
    );
    yield put({
      type: DOCUMENTS_EXPERT_CATEGORIES_GET._SUCCESS,
      response,
      show_all,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertCategoriesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertCategoriesGetWatch() {
  yield takeEvery(
    DOCUMENTS_EXPERT_CATEGORIES_GET._REQUEST,
    documentExpertCategoriesGet
  );
}

function* documentExpertDocumentCreate({ payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documentsExpert.documentExpertDocumentCreate,
      payload
    );
    yield put({ type: DOCUMENTS_EXPERT_DOCUMENT_CREATE._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertDocumentCreate', err);
    //yield put({ type: DOCUMENT_CREATE._ERROR });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertDocumentCreateWatch() {
  yield takeLatest(
    DOCUMENTS_EXPERT_DOCUMENT_CREATE._REQUEST,
    documentExpertDocumentCreate
  );
}

function* documentExpertDocumentDelete({ id, callback, published }) {
  try {
    yield put({ type: LOADER_OPEN });
    yield call(documentsExpert.documentExpertDocumentDelete, id, published);
    yield put({ type: DOCUMENTS_EXPERT_DOCUMENT_DELETE._SUCCESS });
    if (typeof callback === 'function') yield callback();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertDocumentDelete', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertDocumentDeleteWatch() {
  yield takeLatest(
    DOCUMENTS_EXPERT_DOCUMENT_DELETE._REQUEST,
    documentExpertDocumentDelete
  );
}

function* documentExpertSetComment({ id, body }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documentsExpert.documentExpertSetComment,
      { id, body }
    );
    if (response) {
      yield put({ type: DOCUMENT_EXPERT_SET_COMMENT._SUCCESS });
      yield put({ type: DOCUMENT_EXPERT_GET_COMMENTS._REQUEST, id });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertSetComment', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertSetCommentWatch() {
  yield takeLatest(
    DOCUMENT_EXPERT_SET_COMMENT._REQUEST,
    documentExpertSetComment
  );
}

function* documentExpertSetCommentReply({ id, cid, body }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documentsExpert.documentExpertSetCommentReply,
      { id, cid, body }
    );
    if (response) {
      yield put({ type: DOCUMENT_EXPERT_SET_COMMENT_REPLY._SUCCESS });
      yield put({ type: DOCUMENT_EXPERT_GET_COMMENTS._REQUEST, id });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertSetCommentReply', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertSetCommentReplyWatch() {
  yield takeLatest(
    DOCUMENT_EXPERT_SET_COMMENT_REPLY._REQUEST,
    documentExpertSetCommentReply
  );
}

function* documentExpertGetCommentList({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data },
    } = yield call(documentsExpert.documentExpertGetCommentList, id);
    if (data) {
      yield put({ type: DOCUMENT_EXPERT_GET_COMMENTS._SUCCESS, data });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documentsExpert > documentExpertGetCommentList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentExpertGetCommentListWatch() {
  yield takeLatest(
    DOCUMENT_EXPERT_GET_COMMENTS._REQUEST,
    documentExpertGetCommentList
  );
}

export default [
  documentsExpertListGetWatch(),
  documentExpertDetailsGetWatch(),
  documentExpertCategoriesGetWatch(),
  documentExpertDocumentCreateWatch(),
  documentExpertDocumentDeleteWatch(),
  documentExpertSetCommentWatch(),
  documentExpertSetCommentReplyWatch(),
  documentExpertGetCommentListWatch(),
];
